module.exports = __webpack_public_path__ + "static/img/coin.0204cd0a.png";